module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./src/main.js

// To Match the string like: [tets=132], [Test1<=132]
const matchArrayKey = /^\[+([0-9a-z]+)+([\=\>\<]+)+(.+)\]$/i

/* harmony default export */ var main = ({

	getObjectFromArray: function (obj, prop) {
		const arrayKey = prop.match(matchArrayKey)
		if (arrayKey && this.isArray(obj)) {
			const key = arrayKey[1]
			const operator = arrayKey[2]
			const value = arrayKey[3]
			let item = null
			obj.every(function (itm) {
				if (itm[key] !== undefined) {
					const val = itm[key].toString();
					if (
						(operator === '=' && val == value) ||
						(operator === '>=' && val >= value) ||
						(operator === '>' && val > value) ||
						(operator === '<' && val < value) ||
						(operator === '<=' && val <= value) ||
						(operator === '<>' && val != value)
					) {
						item = itm
						return false
					} else {
						return true
					}
				}
				return true
			})
			return item;
		}
		return null;
	},
	/*
	 |----------------------------------------------
	 | To get the value of key from the given object
	 |----------------------------------------------
	 * @param obj => Object
	 * @param props => String, Array, [Object key path],
	 * @param defaultValue => Any, If the key does not exists in object then return the default value.
	 */
	getProp: function (obj, props, defaultValue) {

		props = typeof props === "string" ? props.split('.') : props;
		let prop = props.shift()
		const _obj_in_array = this.getObjectFromArray(obj, prop)
		if (_obj_in_array !== null) {
			obj = _obj_in_array
			prop = props.shift()
		}
		if (!obj || obj[prop] === undefined || !props.length) {
			return !obj || obj[prop] === undefined ? defaultValue : obj[prop];
		}
		return this.getProp(obj[prop], props, defaultValue)
	},
	/*
	 |------------------------------------------------
	 | To delete the key from the given object
	 |-----------------------------------------------
	 * @param obj => Object
	 * @param props => String, Array, [Object key path],
	 */

	deleteProp: function (obj, props) {

		props = typeof props === "string" ? props.split('.') : props;

		const prop = props.shift()

		if (!obj[prop] && prop !== '*') {
			return
		}

		if (prop === '*') {

			obj.map((val, index) => {
				this.deleteProp(obj, [index].concat(props))
			})
		}
		else {

			if (props.length === 1 && this.isInteger(props[0])) {

				obj[prop].splice(parseInt(props[0]), 1);
				return;
			}
			else if (!props.length) {
				external_commonjs_vue_commonjs2_vue_root_Vue_default.a.delete(obj, prop)
				return
			}
			this.deleteProp(obj[prop], props)
		}
	},
	/*
	 |----------------------------------------------
	 | To set the value of key in the given object
	 |----------------------------------------------
	 * @param obj => Object
	 * @param props => String, Array, [Object key path],
	 * @param value => Any, [key value]
	 */
	setProp: function (obj, props, value, replace) {

		props = typeof props === "string" ? props.split('.') : props;
		replace = replace === undefined ? false : replace;

		const prop = props.shift()

		if (!obj[prop]) {

			external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(obj, prop, (props.length >= 1 && this.isInteger(props[0]) ? [] : {}))
		}
		if (!props.length) {

			if (this.isObject(value) && replace === false) {

				var preValue = obj[prop] ? obj[prop] : {};
				external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(obj, prop, { ...preValue, ...value });

			} else {

				external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(obj, prop, value);
			}

			return
		}
		this.setProp(obj[prop], props, value, replace)
	},
	/*
	 |----------------------------------------------
	 | To push the value into the Array
	 |----------------------------------------------
	 * @param obj => Object
	 * @param props => String, Array, [Object key path],
	 * @param value => Array | Object | String,
	 * @param listUniqueKeyName => String, If you want to check the unique object before adding.
	 */
	pushProp: function (obj, props, value, listUniqueKeyName, updateIfExists) {

		props = typeof props === "string" ? props.split('.') : props;
		// Convert the value into Array
		value = !this.isArray(value) ? [value] : value;
		//console.log('pushProp',props, value)
		const prop = props.shift()

		if (!obj[prop]) {
			//console.log('Testing....', prop, props, ( (props.length >= 1  && this.isInteger(props[0]) || props.length ===0 ) ? [] : {}))
			external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(obj, prop, ((props.length >= 1 && this.isInteger(props[0]) || props.length === 0) ? [] : {}))
		}
		if (!props.length) {

			if (obj[prop] !== undefined) {
				let items = obj[prop];
				let first_items = items.slice()
				let max_length = first_items.length;

				value.forEach(function (v, index) {

					let isAlreadyPresent = null;

					if (listUniqueKeyName) {

						first_items.forEach((fi, _index) => {

							if (fi[listUniqueKeyName] == v[listUniqueKeyName]) {
								isAlreadyPresent = true;
								if (updateIfExists) {
									external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(items, _index, { ...fi, ...v })
								}
							}
						})
					}

					if (isAlreadyPresent === null) {
						external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(items, max_length++, v);
					}

				});
			}

			else {
				external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(obj, prop, value);

			}
			return
		}

		this.pushProp(obj[prop], props, value, listUniqueKeyName, updateIfExists)
	},
	/*
	 |----------------------------------------------
	 | To unshift the value into the Array
	 |----------------------------------------------
	 * @param obj => Object
	 * @param props => String, Array, [Object key path],
	 * @param value => Array | Object | String,
	 * @param listUniqueKeyName => String, If you want to check the unique object before adding.
	 */
	unshiftProp: function (obj, props, value, listUniqueKeyName, updateIfExists) {

		props = typeof props === "string" ? props.split('.') : props;
		// Convert the value into Array
		value = !this.isArray(value) ? [value] : value;

		const prop = props.shift()

		if (!obj[prop]) {

			external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(obj, prop, ((props.length >= 1 && this.isInteger(props[0]) || props.length === 0) ? [] : {}))
		}
		if (!props.length) {

			if (obj[prop] !== undefined) {

				let items = obj[prop];

				// Storeing the items which were present before updating..
				let first_items = Object.assign([], items);
				// let max_length = items.length;

				value.forEach(function (v, index) {

					let isAlreadyPresent = null;

					if (listUniqueKeyName) {

						first_items.forEach((fi, _index) => {

							if (fi[listUniqueKeyName] == v[listUniqueKeyName]) {
								isAlreadyPresent = true;
								if (updateIfExists) {
									external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(items, _index, { ...fi, ...v })
								}
							}
						})
					}

					if (isAlreadyPresent === null) {

						items.unshift(v);
					}
				});

			} else {

				external_commonjs_vue_commonjs2_vue_root_Vue_default.a.set(obj, prop, value);
			}

			return
		}

		this.unshiftProp(obj[prop], props, value, listUniqueKeyName, updateIfExists)
	},
	/*
	 |------------------
	 | To check the given object'constructor is array or not
	 |-----------------------------------------
	 * @param value => Object
	 */
	isArray: function (value) {
		return !!value && typeof value === 'object' && value.constructor === Array;
	},
	/*
	 |------------------
	 | To check the given object'constructor is Object or not
	 |-----------------------------------------
	 * @param value => Object
	 */
	isObject: function (value) {
		return !!value && typeof value === 'object' && value.constructor === Object;
	},
	isEmptyObject: function (value) {
		return !this.isObject(value) || Object.keys(value).length === 0
	},
	/*
	 |------------------
	 | To check the given string contains only number or not
	 |-----------------------------------------
	 * @param value => String
	 */
	isInteger: function (value) {

		let regex = new RegExp(/^[0-9]+$/);
		return regex.test(value);
	},
	/*
	 |------------------
	 | To check the given string contains a valid float number
	 |-----------------------------------------
	 * @param value => String
	 */
	isFloat: function (value) {

		let regex = new RegExp(/^-?\d*(\.\d+)$/);
		return regex.test(value);
	},
	/**
	* Covert Query string to Object
	*/
	queryStringToObject: function (url) {

		var params = {};

		var parser = document.createElement('a');
		parser.href = url;
		var query = parser.search.substring(1);
		var vars = query.split('&');
		for (var i = 0; i < vars.length; i++) {
			let pair = vars[i].split('=');
			let key = decodeURIComponent(pair[0])
			let value = decodeURIComponent(pair[1])
			if (key.indexOf('[') !== -1) {
				key = key.split('[').join('.').split(']').join('.').split('..').join('.');
				const lastIndex = key.lastIndexOf('.')
				if (lastIndex !== -1) {
					key = key.substr(0, lastIndex)
					this.setProp(params, key, value)
				}
			} else {
				params[key] = value
			}
		}
		return params;
	},
	/**
	* Convert Query Object to Query String
	* @param obj 
	* @param prefix 
	*/
	objectToQueryString: function (obj, prefix) {

		var str = [],
			p;

		for (p in obj) {
			if (obj.hasOwnProperty(p)) {
				var k = prefix ? prefix + "[" + p + "]" : p,
					v = obj[p];
				const value = (v !== null && typeof v === "object") ?
					this.objectToQueryString(v, k) :
					encodeURIComponent(k) + "=" + encodeURIComponent(v ? v : '')
				if (value) {
					str.push(value)
				}
			}
		}
		return str.join("&");
	},
	/**
	 * To Convert the Object into formData.
	 * @param {Object} obj 
	 * @param {FormData} form 
	 * @param {String} namespace 
	 */
	objectToFormData: function (obj, form, namespace) {

		let fd = form || new FormData();
		let formKey;

		for (let property in obj) {
			if (obj.hasOwnProperty(property)) {
				if (namespace) {
					formKey = namespace + '[' + property + ']';
				} else {
					formKey = property;
				}

				// if the property is an object, but not a File, use recursivity.
				if (obj[property] instanceof Date) {
					fd.append(formKey, obj[property].toISOString());
				}
				else if (typeof obj[property] === 'object' && !(obj[property] instanceof File) && !(obj[property] instanceof Blob)) {
					this.objectToFormData(obj[property], fd, formKey);
				} else { // if it's a string or a File object
					if ((obj[property] instanceof Blob) && obj[property]) {
						fd.append(formKey, obj[property], obj[property].name);
					} else if (obj[property]) {
						fd.append(formKey, obj[property]);
					}
				}
			}
		}

		return fd;
	},
	/**
	 * This function mostly use to rearrange the  object's index base on the delete element
	 * @param obj => Object
	 * @param elementName => element name which is going to delete.
	 */
	reArrangeObjectIndex: function (obj, elementName, clone = false) {
		let errors = clone ? JSON.parse(JSON.stringify(obj)) : obj

		const errorKeys = Object.keys(errors);
		let hasChangedInError = false;

		let elementArr = elementName.split('.');
		let elementLastIndex = elementArr[elementArr.length - 1];
		let isLastIndexInteger = this.isInteger(elementLastIndex);
		let lastIndex = isLastIndexInteger ? parseInt(elementLastIndex) : null;
		let elementPath = elementArr.slice(0, -1).join('.');
		const regex = new RegExp("(" + elementPath + ".)+[0-9]+");

		errorKeys.forEach(function (item) {

			// If the Parent Element's error is deleting then deleting all the child element errors also.
			// If the element contains the number in end of name then search the child element index and process to deleting.
			if (item.indexOf(elementName) === 0) {
				delete errors[item];
				hasChangedInError = true;
			}

			//if deleting the Array element's Error then reArrange the errors indexing..
			let elementNextIndex = regex.exec(item);

			if (lastIndex !== null && elementNextIndex) {
				const elValueWithIndex = elementNextIndex[1];
				const elementNameWithKey = elementNextIndex[0];
				elementNextIndex[0].replace(elValueWithIndex, '');
				elementNextIndex = parseInt(elementNextIndex[0].replace(elementNextIndex[1], ''));
				if (elementNextIndex > lastIndex) {

					const newIndex = elementNextIndex - 1;
					const oldIndexVal = errors[item];
					const newItemIndex = item.replace(elementNameWithKey, elValueWithIndex + newIndex)

					delete errors[item];
					errors[newItemIndex] = oldIndexVal;
					hasChangedInError = true;
				}

			}
		});

		return hasChangedInError ? errors : null;
	}
});

/**
 * To the check the select file is an image.
 * @param {String} dataURL 
 */
function isImage(dataURL) {
	try {
		const mimeType = dataURL.split(",")[0].split(":")[1].split(";")[0];
		return !!mimeType.match('image.*');
	} catch (e) {
		return false
	}
}
/**
 * To get the file extension.
 * @param {String} name 
 */
function getFileExt(name) {
	let name_arr = name.split('.');
	return name_arr[name_arr.length - 1];
}
/**
 * To verify the file Extensions 
 * @param {Array} acceptedFiles 
 * @param {File Instance} file 
 */
function checkFileExtensions(acceptedFiles, file) {

	const fileName = file.name;
	const fileType = file.type
	let is_valid = false;
	acceptedFiles.map(function (file_type) {

		if (file_type.startsWith('.')) {

			var ext = getFileExt(fileName);
			var patt = new RegExp(file_type.replace('.', ''), 'gmi');

			if (patt.test(ext) === true) {

				is_valid = true;
			}
		}
		else {

			let match_with = file_type;
			let patt = '';

			if (file_type.endsWith('*')) {

				match_with.slice(0, -1);
				patt = new RegExp('^' + match_with, 'gmi');

			}
			else {

				patt = new RegExp(match_with, 'gmi');
			}


			if (patt.test(fileType) === true) {

				is_valid = true;
			}

		}
	})

	return is_valid;
}

/**
 * To replace all searched keyword from string.
 */
String.prototype.replaceAll = function (search, replacement) {
	var target = this;
	return target.split(search).join(replacement);
};
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js
/* concated harmony reexport isImage */__webpack_require__.d(__webpack_exports__, "isImage", function() { return isImage; });
/* concated harmony reexport getFileExt */__webpack_require__.d(__webpack_exports__, "getFileExt", function() { return getFileExt; });
/* concated harmony reexport checkFileExtensions */__webpack_require__.d(__webpack_exports__, "checkFileExtensions", function() { return checkFileExtensions; });


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (main);



/***/ })

/******/ });
//# sourceMappingURL=lq.helper.common.js.map